import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _effectorFileName = "/builds/gmini/front-common/src/Services/EstimationService/EstimationCalculateService.ts";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.values.js";
import { createStore, merge } from 'effector';
import * as api from '@gmini/sm-api-sdk/lib/EstimationApi';
export function createEstimationCalculateService() {
  var calculation$ = createStore({}, {
    name: "calculation$",
    sid: "vjlxzr"
  }).on(merge([api.Estimation.getMostRecent.defaultContext.doneData, api.Estimation.fetch.defaultContext.doneData, api.Estimation.ImportEstimation.defaultContext.doneData], {
    name: "calculation$",
    sid: "3c7wxa"
  }), function (_, p) {
    return p.calculations.reduce(function (acc, calculation) {
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, calculation.id, calculation));
    }, {});
  }).on(api.EstimationCalculation.remove.done, function (state, _ref) {
    var params = _ref.params;

    if (state[params.calculationId]) {
      var next = _objectSpread({}, state);

      delete next[params.calculationId];
      return next;
    }

    return state;
  });
  return {
    calculation$: calculation$
  };
}
export function buildRuleKey(_ref2) {
  var estimationId = _ref2.estimationId,
      estimationVersion = _ref2.estimationVersion;
  return "".concat(estimationId, ":").concat(estimationVersion);
}
export function findCalculationByGroupId(calculations, groupId) {
  return Object.values(calculations).find(function (r) {
    return (r === null || r === void 0 ? void 0 : r.groupId) === +groupId;
  }) || null;
}